module.exports = __webpack_public_path__ + "img/linkus-wms.2247d446.png";